import type { MosaicContainer } from "../particle";
import type { Drawing } from "./drawing";

const saveWorker = new Worker(new URL("./worker.ts", import.meta.url), {
  type: "module",
});

export function saveMosaic(container: MosaicContainer): void {
  if (!container.isStarted()) {
    return;
  }
  saveWorker.postMessage({ type: "save", drawing: container.toDrawing() });
}

export function initInProgress(container: MosaicContainer): Promise<boolean> {
  return new Promise((resolve) => {
    const handler = (e: MessageEvent<{ type: string; drawing?: Drawing }>) => {
      if (e.data.type !== "init") return;
      saveWorker.removeEventListener("message", handler);
      const d = e.data.drawing;
      if (d) {
        container.fromDrawing(d).then(() => resolve(true));
      } else {
        resolve(false);
      }
    };
    saveWorker.addEventListener("message", handler);
    saveWorker.postMessage({ type: "init" });
  });
}

/**
 * Request deletion of a saved drawing by ID.
 */
export function deleteDrawing(id: string): void {
  saveWorker.postMessage({ type: "delete", id });
}
